import IaService from "@/services/serviceApi";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { QUERY_REFRESH_INTERVALS } from "@/constants/queryRefresh";

const CHECK_VERSION_TOAST_ID = 'check-version';

export default function CheckVersion() {
    const { t } = useTranslation();
    const { data: versao, error } = useQuery({
        queryKey: ['versao'],
        refetchInterval: QUERY_REFRESH_INTERVALS.appVersion,
        refetchOnWindowFocus: false,
        queryFn: async () => {
            return await IaService.getVersion(__APP_VERSION__);
        },
        // enabled: import.meta.env.DEV,
        enabled: import.meta.env.PROD,
    });

    useEffect(() => {
        const hasUpdate = !!versao?.data?.hasUpdate;

        if (versao && !error && !hasUpdate) {
            toast.dismiss(CHECK_VERSION_TOAST_ID);
            return;
        }

        if (versao && !error && hasUpdate) {
            toast(() => {
                const updatePage = () => {
                    toast.dismiss(CHECK_VERSION_TOAST_ID);

                    const nextUrl = new URL(window.location.href);
                    nextUrl.searchParams.set('_v', String(Date.now()));
                    window.location.replace(nextUrl.toString());
                };

                return (
                    <div className="text-sm">
                        <p className="text-blue-400"><strong>{t("common:version.new_version_available")}</strong></p>
                        <p className="text-xs">{t("common:version.update_for_better_experience")}</p>
                        <div className="flex justify-center mt-1">
                            <button onClick={updatePage} className="bg-blue-400 text-white px-2 py-1 rounded-md">{t("common:version.update")}</button>
                        </div>
                    </div>
                );
            },
                {
                    closeOnClick: true,
                    autoClose: false,
                    closeButton: false,
                    draggable: false,
                    toastId: CHECK_VERSION_TOAST_ID,
                }
            );
        }
    }, [versao, error, t]);
    return null;
}
